// // Update your existing doctors section with React Router Links

// import React from 'react';
// import { Link } from 'react-router-dom';
// import { Award, Activity, ChevronRight } from 'lucide-react';

// const DoctorsSection = () => {
//   const doctors = [
//     {
//       id: 1,
//       slug: 'dr-naveen-chandra-tej',
//       name: 'Dr. P Naveen Chandra Tej',
//       specialty: 'Interventional Cardiologist',
//       experience: '5+ Years',
//       education: 'MBBS, MD, DM Cardiology',
//       description: 'Consultant Interventional Cardiologist specializing in complex cardiac procedures',
//       image: 'https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?w=800&q=90'
//     },
//     {
//       id: 2,
//       slug: 'dr-swathi-reddy-gadam',
//       name: 'Dr. Swathi Reddy Gadam',
//       specialty: 'Obstetrician & Gynecologist',
//       experience: '10+ Years',
//       education: 'MBBS, MS (OBG), DNB, FMAS',
//       description: 'Expert in High Risk Pregnancy, Laparoscopic Surgery & Infertility Treatment',
//       image: 'https://images.unsplash.com/photo-1559839734-2b71ea197ec2?w=800&q=90'
//     },
//     {
//       id: 3,
//       slug: 'dr-sravan-kumar-yadav',
//       name: 'Dr. Sravan Kumar Yadav',
//       specialty: 'Emergency Medicine Specialist',
//       experience: '10+ Years',
//       education: 'DEM, MRCEM, FCD',
//       description: 'HOD Emergency Medicine, Expert in Critical Care & Diabetic Management',
//       image: 'https://images.unsplash.com/photo-1622253692010-333f2da6031d?w=800&q=90'
//     }
//   ];

//   return (
//     <>
//       <style>{`
//         .doctors-section {
//           padding: 6rem 2rem;
//           background: linear-gradient(135deg, #F8FAFB 0%, white 100%);
//         }

//         .section-header {
//           text-align: center;
//           max-width: 800px;
//           margin: 0 auto 4rem;
//         }

//         .section-label {
//           font-size: 0.95rem;
//           font-weight: 700;
//           color: #E86A33;
//           letter-spacing: 3px;
//           text-transform: uppercase;
//           margin-bottom: 1rem;
//           display: block;
//         }

//         .section-title {
//           font-family: 'Playfair Display', serif;
//           font-size: 3rem;
//           font-weight: 800;
//           color: #1B4965;
//           margin-bottom: 1.5rem;
//         }

//         .about-text {
//           font-size: 1.1rem;
//           line-height: 1.8;
//           color: #666;
//         }

//         .doctors-grid {
//           max-width: 1400px;
//           margin: 0 auto;
//           display: grid;
//           grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
//           gap: 3rem;
//         }

//         .doctor-card {
//           background: white;
//           border-radius: 25px;
//           overflow: hidden;
//           box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08);
//           transition: all 0.4s ease;
//           cursor: pointer;
//         }

//         .doctor-card:hover {
//           transform: translateY(-10px);
//           box-shadow: 0 20px 60px rgba(27, 73, 101, 0.15);
//         }

//         .doctor-image-wrapper {
//           position: relative;
//           height: 350px;
//           overflow: hidden;
//         }

//         .doctor-image {
//           width: 100%;
//           height: 100%;
//           object-fit: cover;
//           transition: transform 0.4s ease;
//         }

//         .doctor-card:hover .doctor-image {
//           transform: scale(1.1);
//         }

//         .doctor-overlay {
//           position: absolute;
//           bottom: 0;
//           left: 0;
//           right: 0;
//           background: linear-gradient(to top, rgba(27, 73, 101, 0.95), transparent);
//           padding: 2rem;
//           transform: translateY(20px);
//           opacity: 0;
//           transition: all 0.4s ease;
//         }

//         .doctor-card:hover .doctor-overlay {
//           transform: translateY(0);
//           opacity: 1;
//         }

//         .doctor-specialty {
//           color: white;
//           font-weight: 700;
//           font-size: 1.1rem;
//         }

//         .doctor-content {
//           padding: 2rem;
//         }

//         .doctor-name {
//           font-size: 1.5rem;
//           font-weight: 800;
//           color: #1B4965;
//           margin-bottom: 1rem;
//           font-family: 'Playfair Display', serif;
//         }

//         .doctor-info {
//           display: flex;
//           flex-direction: column;
//           gap: 0.8rem;
//           margin-bottom: 1.5rem;
//         }

//         .info-row {
//           display: flex;
//           align-items: center;
//           gap: 0.8rem;
//           color: #666;
//           font-size: 0.95rem;
//         }

//         .info-row svg {
//           color: #E86A33;
//         }

//         .doctor-description {
//           font-size: 0.95rem;
//           line-height: 1.7;
//           color: #666;
//           margin-bottom: 1.5rem;
//         }

//         .read-more-btn {
//           display: inline-flex;
//           align-items: center;
//           gap: 0.5rem;
//           color: #E86A33;
//           font-weight: 700;
//           font-size: 0.95rem;
//           text-decoration: none;
//           transition: all 0.3s ease;
//         }

//         .read-more-btn:hover {
//           gap: 1rem;
//           color: #1B4965;
//         }

//         @media (max-width: 768px) {
//           .section-title {
//             font-size: 2rem;
//           }

//           .doctors-grid {
//             grid-template-columns: 1fr;
//           }
//         }
//       `}</style>

//       <section className="doctors-section" id="doctors">
//         <div className="section-header">
//           <span className="section-label">Our Medical Team</span>
//           <h2 className="section-title">Meet Our Expert Doctors</h2>
//           <p className="about-text">
//             Our team of highly qualified specialists brings years of experience and expertise in their respective fields
//           </p>
//         </div>

//         <div className="doctors-grid">
//           {doctors.map((doctor) => (
//             <div key={doctor.id} className="doctor-card">
//               <div className="doctor-image-wrapper">
//                 <img src={doctor.image} alt={doctor.name} className="doctor-image" />
//                 <div className="doctor-overlay">
//                   <div className="doctor-specialty">{doctor.specialty}</div>
//                 </div>
//               </div>
//               <div className="doctor-content">
//                 <h3 className="doctor-name">{doctor.name}</h3>
//                 <div className="doctor-info">
//                   <div className="info-row">
//                     <Award size={16} />
//                     <span>{doctor.experience} Experience</span>
//                   </div>
//                   <div className="info-row">
//                     <Activity size={16} />
//                     <span>{doctor.education}</span>
//                   </div>
//                 </div>
//                 <p className="doctor-description">{doctor.description}</p>
//                 <Link to={`/doctors/${doctor.slug}`} className="read-more-btn">
//                   Read More
//                   <ChevronRight size={18} />
//                 </Link>
//               </div>
//             </div>
//           ))}
//         </div>
//       </section>
//     </>
//   );
// };

// export default DoctorsSection;

// Update your existing doctors section with React Router Links

import React from 'react';
import { Link } from 'react-router-dom';
import { Award, Activity, ChevronRight } from 'lucide-react';
import doctor1 from './Images/doctor1.jpeg';
import doctor2 from './Images/doctor2.jpeg';
import doctor3 from './Images/doctor3.jpeg';

const DoctorsSection = () => {
  const doctors = [
    {
      id: 1,
      slug: 'dr-naveen-chandra-tej',
      name: 'Dr. P Naveen Chandra Tej',
      specialty: 'Interventional Cardiologist',
      experience: '5+ Years',
      education: 'MBBS, MD, DM Cardiology',
      description: 'Consultant Interventional Cardiologist specializing in complex cardiac procedures',
      image: doctor2
    },
    {
      id: 2,
      slug: 'dr-swathi-reddy-gadam',
      name: 'Dr. Swathi Reddy Gadam',
      specialty: 'Obstetrician & Gynecologist',
      experience: '10+ Years',
      education: 'MBBS, MS (OBG), DNB, FMAS',
      description: 'Expert in High Risk Pregnancy, Laparoscopic Surgery & Infertility Treatment',
      image: doctor1
    },
    {
      id: 3,
      slug: 'dr-sravan-kumar-yadav',
      name: 'Dr. Sravan Kumar Yadav',
      specialty: 'Emergency Medicine Specialist',
      experience: '10+ Years',
      education: 'DEM, MRCEM, FCD',
      description: 'HOD Emergency Medicine, Expert in Critical Care & Diabetic Management',
      image: doctor3
    }
  ];

  return (
    <>
      <style>{`
        .doctors-section {
          padding: 6rem 2rem;
          background: linear-gradient(135deg, #F8FAFB 0%, white 100%);
        }

        .section-header {
          text-align: center;
          max-width: 800px;
          margin: 0 auto 4rem;
        }

        .section-label {
          font-size: 0.95rem;
          font-weight: 700;
          color: #E86A33;
          letter-spacing: 3px;
          text-transform: uppercase;
          margin-bottom: 1rem;
          display: block;
        }

        .section-title {
          font-family: 'Playfair Display', serif;
          font-size: 3rem;
          font-weight: 800;
          color: #1B4965;
          margin-bottom: 1.5rem;
        }

        .about-text {
          font-size: 1.1rem;
          line-height: 1.8;
          color: #666;
        }

        .doctors-grid {
          max-width: 1400px;
          margin: 0 auto;
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
          gap: 3rem;
        }

        .doctor-card {
          background: white;
          border-radius: 25px;
          overflow: hidden;
          box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08);
          transition: all 0.4s ease;
          cursor: pointer;
        }

        .doctor-card:hover {
          transform: translateY(-10px);
          box-shadow: 0 20px 60px rgba(27, 73, 101, 0.15);
        }

        .doctor-image-wrapper {
          position: relative;
          height: 400px;
          overflow: hidden;
        }

        .doctor-image {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.4s ease;
        }

        .doctor-card:hover .doctor-image {
          transform: scale(1.1);
        }

        .doctor-overlay {
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          background: linear-gradient(to top, rgba(27, 73, 101, 0.95), transparent);
          padding: 2rem;
          transform: translateY(20px);
          opacity: 0;
          transition: all 0.4s ease;
        }

        .doctor-card:hover .doctor-overlay {
          transform: translateY(0);
          opacity: 1;
        }

        .doctor-specialty {
          color: white;
          font-weight: 700;
          font-size: 1.1rem;
        }

        .doctor-content {
          padding: 2rem;
        }

        .doctor-name {
          font-size: 1.5rem;
          font-weight: 800;
          color: #1B4965;
          margin-bottom: 1rem;
          font-family: 'Playfair Display', serif;
        }

        .doctor-info {
          display: flex;
          flex-direction: column;
          gap: 0.8rem;
          margin-bottom: 1.5rem;
        }

        .info-row {
          display: flex;
          align-items: center;
          gap: 0.8rem;
          color: #666;
          font-size: 0.95rem;
        }

        .info-row svg {
          color: #E86A33;
        }

        .doctor-description {
          font-size: 0.95rem;
          line-height: 1.7;
          color: #666;
          margin-bottom: 1.5rem;
        }

        .read-more-btn {
          display: inline-flex;
          align-items: center;
          gap: 0.5rem;
          color: #E86A33;
          font-weight: 700;
          font-size: 0.95rem;
          text-decoration: none;
          transition: all 0.3s ease;
        }

        .read-more-btn:hover {
          gap: 1rem;
          color: #1B4965;
        }

        @media (max-width: 768px) {
          .section-title {
            font-size: 2rem;
          }

          .doctors-grid {
            grid-template-columns: 1fr;
          }
        }
      `}</style>

      <section className="doctors-section" id="doctors">
        <div className="section-header">
          <span className="section-label">Our Medical Team</span>
          <h2 className="section-title">Meet Our Expert Doctors</h2>
          <p className="about-text">
            Our team of highly qualified specialists brings years of experience and expertise in their respective fields
          </p>
        </div>

        <div className="doctors-grid">
          {doctors.map((doctor) => (
            <div key={doctor.id} className="doctor-card">
              <div className="doctor-image-wrapper">
                <img src={doctor.image} alt={doctor.name} className="doctor-image" />
                <div className="doctor-overlay">
                  <div className="doctor-specialty">{doctor.specialty}</div>
                </div>
              </div>
              <div className="doctor-content">
                <h3 className="doctor-name">{doctor.name}</h3>
                <div className="doctor-info">
                  <div className="info-row">
                    <Award size={16} />
                    <span>{doctor.experience} Experience</span>
                  </div>
                  <div className="info-row">
                    <Activity size={16} />
                    <span>{doctor.education}</span>
                  </div>
                </div>
                <p className="doctor-description">{doctor.description}</p>
                <Link to={`/doctors/${doctor.slug}`} className="read-more-btn">
                  Read More
                  <ChevronRight size={18} />
                </Link>
              </div>
            </div>
          ))}
        </div>
      </section>
    </>
  );
};

export default DoctorsSection;